import { Form, Input, Modal } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { RULES } from '@/constants';
import { useCourseDetail, useFolderForm, useMutateCourses } from '@/store';

type Values = { name: string };

export const FolderForm = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation(['DefaultTranslations', 'CourseTranslations']);
  const { data, isOpen, setIsOpen, setData } = useFolderForm();
  const { course } = useCourseDetail();
  const { createFolder, updateFolderName } = useMutateCourses();

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  const handleFinish = ({ name }: Values) => {
    if (!course) return;
    if (data) {
      updateFolderName(course._id, data, name);
    } else {
      createFolder({ courseId: course._id, name });
    }
    onClose();
  };

  const onClose = () => {
    setIsOpen(false);
    setData(undefined);
    form.resetFields();
  };

  return (
    <Modal
      open={isOpen}
      onOk={form.submit}
      onCancel={onClose}
      title={t(data ? 'CourseTranslations:UPDATE_SECTION' : 'CourseTranslations:CREATE_SECTION')}
      cancelText={t('DefaultTranslations:CANCEL')}
      okText={t(data ? 'CourseTranslations:SAVE' : 'CourseTranslations:CREATE')}>
      <Form form={form} onFinish={handleFinish}>
        <Form.Item name="name" rules={[RULES.REQUIRED]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
